import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  class: "notification-bell-dot rounded-circle",
  id: "notification-bell-dot"
}

import { computed } from "vue";
import { useNotifications } from "@/composables/useNotifications";
import { EOffcanvasViews, navigateCanvas } from "@/views/OffcanvasViews/OffcanvasViewsConfig";


export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationBell',
  props: {
    id: { default: "notification-bell" },
    size: { default: 26 },
    label: { type: Boolean, default: false }
  },
  setup(__props: any) {


const { data } = useNotifications();
const hasUnread = computed(() => (data.value ?? []).some((n: any) => !n.read));
const openNotifications = () => navigateCanvas(EOffcanvasViews.notifications);

return (_ctx: any,_cache: any) => {
  const _component_PhIcons = _resolveComponent("PhIcons")!

  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: _normalizeClass(["notification-bell", { 'nav-link text-paragraph d-flex align-items-center gap-2': __props.label }]),
    id: __props.id,
    "aria-label": "Notificações",
    onClick: openNotifications
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(["position-relative d-inline-flex", { 'notification-bell-icon': __props.label }])
    }, [
      _createVNode(_component_PhIcons, {
        name: "bell",
        size: __props.label ? 18 : __props.size,
        color: "primary"
      }, null, 8, ["size"]),
      (hasUnread.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2))
        : _createCommentVNode("", true)
    ], 2),
    (__props.label)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createTextVNode("Notificações")
        ], 64))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})